import React from "react";
import Nav from "../Components/Navbar";
import Footer from "../Components/Footer";
import About from "../Components/About";
import Order from "../Components/Order";

const Home = () => {
  return (
    <>
      <Nav />
      <Order />
      <About />
      <Footer />
    </>
  );
};

export default Home;
